import { RestError } from "../../services/rest-service/RestService";
import { useMutation } from "react-query";
import PageConfigurationService from "../../services/page-configuration-service/PageConfigurationService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { useSavePageConfiguration } from "./UseSavePageConfiguration";


export type UseRenamePageConfigurationResultType = {
    oldName: string;
    newName: string;
};

export type UseRenamePageConfigurationParameters = {
    groupID: number,
    configurationID: number;
} & BaseUseMutationParameters<UseRenamePageConfigurationResultType, string>;

export function useRenamePageConfiguration({
    groupID,
    configurationID,
    onError,
    onSuccess
}: UseRenamePageConfigurationParameters) {

    const { mutateAsync: saveConfiguration } = useSavePageConfiguration({
        groupID
    });
    
    return useMutation<UseRenamePageConfigurationResultType, RestError, string>(
        async (name) => {

            const model = await PageConfigurationService.getAccessiblePageConfiguration4(groupID, configurationID);
            const oldName = model.name;
            model.name = name;

            await saveConfiguration(model);

            return {
                oldName: oldName,
                newName: name
            };
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}
